import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface DataInboxPluginContainerProps {
  operationsSelected: Operation[]
}

const S3Plugin = React.lazy(() => importFromS3('data-inbox'));

export const DataInboxPluginContainer: React.FC<DataInboxPluginContainerProps> = ({ operationsSelected }: DataInboxPluginContainerProps) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.dataInbox.module-federation'];

  const DataInboxPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('dataInboxWeb/DataInboxWeb'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  const { isLoading, operation } = useImpersonatedOperation();
  const operationSelected = operation || operationsSelected[0];

  // prevent rendering Data Inbox if we're fetching operations
  if (isLoading || !operationSelected?.operationOwnerId) return null;

  const operationUserId = Number(operationSelected.operationOwnerId);

  return (
    <DataInboxPlugin
      operationSelected={operationSelected}
      operationUserId={operationUserId}
    />
  );
};
